const NullField = (): null => null;

export default NullField;
